<template>
  <div class="vktimezone" :class="{ m: $ctx.isMO() }">
    <span class="tzname">{{tzName}}</span>
    <span class="timetick">{{timeTick.value}}</span>
    <div v-if="!isMatchServerTime" class="tips">{{ res.serverTimeCheck }}</div>
  </div>
</template>

<style lang="less">
.vktimezone {
  display: flex;
  position: relative;
  font-size: 0.12rem;
  color: #464C54;
  .tips {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    width: 2.64rem;
    padding: 0.19rem 0.26rem;
    line-height: 0.14rem;
    color: #fff;
    background: rgba(0, 0, 0, 0.54);
    border-radius: 0.12rem;
  }
  &.m {
    color: #9199A3;
    .timetick, .tips {
      display: none;
    }
  }
  .timetick {
    margin-left: 0.03rem;
  }
}
</style>

<script>
import { hobbitComponent } from 'hobbit-base';
import { getTimezoneName } from 'hobbit-base/modules/utils';

export default hobbitComponent({
  name: 'vktimezone',
  props: {
    showTime: {
      type: Boolean,
      default: true,
    },
    openCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tzName: '',
      serverTime: null,
      timeTick: {
        interval: null,
        value: '',
      },
    };
  },
  computed: {
    isMatchServerTime() {
      if (!this.serverTime) return true;
      return Math.abs(this.serverTime - Date.now()) <= 5 * 60 * 1000;
    },
  },
  created() {
    const agentInfo = this.$ctx.agentInfo;
    if (agentInfo?.timezone) {
      this.tzName = agentInfo.timezone ?? '';
    } else {
      this.tzName = getTimezoneName() ?? '';
    }

    if (!this.$ctx.isMO()) {
      this.refreshTimeTick();
      this.timeTick.interval = window.setInterval(this.refreshTimeTick, 1e3);
    }
  },
  destroyed() {
    if (this.timeTick.interval) {
      window.clearInterval(this.timeTick.interval);
    }
  },
  methods: {
    refreshTimeTick() {
      const time = new Date(this.$ctx.now());
      const timezone = this.$ctx.vkTimezone;
      this.timeTick.value = time.toOffsetDate(timezone).format('hh:mm:ss');
      if (time.getSeconds() === 0) {
        const agentInfo = this.$ctx.agentInfo;
        if (agentInfo?.timezone) {
          this.tzName = agentInfo.timezone ?? '';
        } else {
          this.tzName = getTimezoneName() ?? '';
        }
      }
    },
    // getTimezoneByNum() {
    //   let timezoneMatchs = /GMT([+-])(\d{2}):(\d{2})/.exec(this.$ctx.vkTimezone);
    //   return parseFloat(`${timezoneMatchs[1]}${(+timezoneMatchs[2]+timezoneMatchs[3]/60.0)}`)
    // },
  },
});
</script>
